import { Http } from "@shared/svelte/Modules/ApiService";
import * as _ from 'lodash';

const getRepsInternal = function(distributorId, cb) {
  if (_.get(window['$rootScope'], 'user.role') == 'supplier') { return; }

  return Http({
    method: 'GET',
    url: '/api/retailer/distributors/' + distributorId + '/sales_reps',
    data: { include_integrated_reps: true }
  }, function(res) {
    cb(res);
  }, function() {})
};

var service = function($http, $rootScope) {
  var getReps = getRepsInternal

  return {
    getReps: getReps
  };
};

service.$inject = ['$http','$rootScope'];

tiz.service('SalesReps', service);
export default { getReps: getRepsInternal }